// Whole-screen states (mockup stateScreen): the h1 is the screen that was asked for, the box says why.
//   noAccess — a menu the person does not have, opened by address ("이 화면을 볼 권한이 없어요" + [홈으로])
//   notFound — an unknown address · notReady — a menu screen not built yet · error — drawing failed ([지금 다시 시도]).
// Out-of-scope record/person details are the screens' job ("찾을 수 없어요" without saying whether it exists).
import { useLocation } from 'react-router';
import { useMyRole } from '../auth/AuthContext';
import { useT } from '../i18n';
import { PageHead, Screen } from '../ui/Layout';
import { Empty, ErrorState } from '../ui/States';
import { useRouteHandle } from './view';

export function StateScreen({ kind, onRetry, page }: { kind: 'noAccess' | 'notFound' | 'notReady' | 'error'; onRetry?: () => void; page?: string }) {
  const t = useT();
  const myRole = useMyRole();
  const location = useLocation();
  const handle = useRouteHandle();
  const title = page ?? (handle && kind !== 'notFound' ? t(handle.titleKey) : t('state.notFound.page'));
  const route = location.pathname;
  const role = myRole.name;
  return (
    <Screen name="state">
      <PageHead title={title} />
      {kind === 'noAccess' ? (
        <Empty icon="lock" title={t('state.noAccess.title')} desc={t('state.noAccess.desc', { role, page: title })} action={{ label: t('common.goHome'), to: '/home' }} />
      ) : kind === 'notFound' ? (
        <Empty icon="search" title={t('state.notFound.title')} desc={t('state.notFound.desc', { route, page: title })} action={{ label: t('common.goHome'), to: '/home' }} />
      ) : kind === 'notReady' ? (
        <Empty title={t('state.notReady.title')} desc={t('state.notReady.desc', { route, page: title })} action={{ label: t('common.goHome'), to: '/home' }} />
      ) : (
        <ErrorState title={t('state.error.title')} desc={t('state.error.desc')} onRetry={onRetry} />
      )}
    </Screen>
  );
}
